import React, { useEffect, useState } from "react";
import "./createProjectModal.css";

export default function CreateProjectModal({
  open,
  onClose,
  onSubmit,
  loading,
  error,
}) {
  const [title, setTitle] = useState("");

  useEffect(() => {
    if (open) {
      setTitle("");
    }
  }, [open]);

  if (!open) return null;

  function handleBackdrop(e) {
    if (e.target.classList.contains("modal-backdrop")) onClose();
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!title.trim() || loading) return;
    onSubmit(title.trim());
  }

  return (
    <div className="modal-backdrop" onMouseDown={handleBackdrop}>
      <div className="modal-card" role="dialog" aria-modal="true">
        <div className="modal-header">
          <h2 className="modal-title">Nouveau projet</h2>
          <button className="modal-close" onClick={onClose} type="button">
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-body">
          <label className="modal-label">
            Titre du projet
            <input
              className="modal-input"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="ex: Projet test PCB"
              autoFocus
              disabled={loading}
            />
          </label>

          {error ? <div className="modal-error">{error}</div> : null}

          <div className="modal-actions">
            <button
              type="button"
              className="modal-btn secondary"
              onClick={onClose}
              disabled={loading}
            >
              Annuler
            </button>
            <button type="submit" className="modal-btn" disabled={loading || !title.trim()}>
              {loading ? "Création..." : "Créer"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
